import { Button } from '@chakra-ui/button';
import { Checkbox } from '@chakra-ui/checkbox';
import { IoIosArrowDown } from 'react-icons/io';

import { Box, Text } from '@chakra-ui/layout';
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger
} from '@chakra-ui/popover';
import { Portal } from '@chakra-ui/portal';
import { Icon, useDisclosure } from '@chakra-ui/react';
import React from 'react';

export function DropdownCheckbox({
  label,
  quantitySelected,
  setValue,
  onOpen,
  options,
  defaultValue,
  ...props
}) {
  const { isOpen, onToggle, onClose } = useDisclosure();
  return (
    <Popover autoFocus={false} isOpen={isOpen} onOpen={onOpen} onClose={onClose} closeOnBlur={true}>
      <PopoverTrigger>
        <Button
          w="100%"
          maxW="290px"
          h="37px"
          display="flex"
          alignItems="center"
          justifyContent="start"
          fontSize="12px"
          bgColor="#EDF2F7"
          outline="0"
          _focus={{
            boxShadow: '0'
          }}
          {...(isOpen && {
            bgColor: '#378BBF',
            color: 'white',
            _hover: { bgColor: '#378BBF' }
          })}
          onClick={onToggle}
          {...props}>
          {label} ({quantitySelected || 0})
          <Icon
            as={IoIosArrowDown}
            ml="auto"
            transition="transform 0.3s"
            transform={isOpen ? 'rotate(180deg)' : 'rotate(0)'}
            color={isOpen ? 'white' : '#378BBF'}
          />
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            {/* create checkbox and label */}
            {options.map((item) => (
              <CheckboxItem
                key={item.value}
                item={item}
                setValue={setValue}
                isChecked={defaultValue}
              />
            ))}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}

function CheckboxItem({ item, setValue, isChecked }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={5}
      h="37px"
      px={2}
      fontWeight="bold"
      fontSize="12px"
      borderBottom={'1px solid #DBDBDB'}
      pb={3}
      mb={3}>
      <Checkbox
        id={item.id}
        size="lg"
        borderColor="#378BBF"
        borderRadius={0}
        defaultChecked={isChecked?.includes(item.value)}
        onChange={() => setValue(item)}
      />
      <Text as={'label'} htmlFor={item.id} color="#1D1D1D" fontSize="12px" fontWeight="normal">
        {item.label}
      </Text>
    </Box>
  );
}
